export default [
    {
        value: "",
        name: "Any",
        icon: "sliders horizontal"
    },
    {
        value: "9",
        name: "General Knowledge",
        icon: "cloud"
    },
    {
        value: "10",
        name: "Books",
        icon: "book"
    },
    {
        value: "11",
        name: "Film",
        icon: "film"

    },
    {
        value: "12",
        name: "Music",
        icon: "music"
    },
    {
        value: "13",
        name: "Musicals & Theatres",
        icon: "podcast"
    },
    {
        value: "14",
        name: "Television",
        icon: "tv"
    },
    {
        value: "15",
        name: "Video Games",
        icon: "gamepad"
    },
    {
        value: "16",
        name: "Board Games",
        icon: "chess"
    },
    {
        value: "17",
        name: "Science & Nature",
        icon: "rocket"
    },
    {
        value: "18",
        name: "Computers",
        icon: "laptop"
    },
    {
        value: "19",
        name: "Mathematic",
        icon: "calculator"
    },
    {
        value: "20",
        name: "Mythology",
        icon: "eye"
    },
    {
        value: "21",
        name: "Sports",
        icon: "football ball"
    },
    {
        value: "22",
        name: "Geography",
        icon: "tree"
    },
    {
        value: "23",
        name: "History",
        icon: "globe"
    },
    {
        value: "24",
        name: "Politics",
        icon: "bullhorn"
    },
    {
        value: "25",
        name: "Art",
        icon: "paint brush"
    },
    {
        value: "26",
        name: "Celebrities",
        icon: "star"
    },
    {
        value: "27",
        name: "Animals",
        icon: "sticker mule"
    },
    {
        value: "28",
        name: "Vehicles",
        icon: "truck"
    },
    {
        value: "29",
        name: "Comics",
        icon: "newspaper"
    },
    {
        value: "30",
        name: "Gadgets",
        icon: "headphones"
    },
    {
        value: "31",
        name: "Japanese Anime & Manga",
        icon: "certificate"
    },
    {
        value: "32",
        name: "Cartoon & Animations",
        icon: "smile"
    } 
]